"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _reactToastify = require("react-toastify");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var WalletButtonsWithdraw = function WalletButtonsWithdraw(_ref) {
  var translations = _ref.translations,
      currencySymbol = _ref.currencySymbol,
      getWallet = _ref.getWallet,
      onError = _ref.onError,
      balance = _ref.balance;

  var _useState = (0, _react.useState)({
    withdrawAmount: "",
    withdrawAmountPassword: ""
  }),
      _useState2 = _slicedToArray(_useState, 2),
      form = _useState2[0],
      setForm = _useState2[1];

  var withdrawAmount = form.withdrawAmount,
      withdrawAmountPassword = form.withdrawAmountPassword,
      errorMessage = form.errorMessage,
      isSaving = form.isSaving,
      password = form.password,
      amount = form.amount;

  var handleTextboxChanged = function handleTextboxChanged(e) {
    var _e$target = e.target,
        value = _e$target.value,
        name = _e$target.name;
    setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, name, value)));
  };

  var withdraw = function withdraw(amount, pin) {
    setForm(_objectSpread(_objectSpread({}, form), {}, {
      isSaving: true,
      error: ""
    }));

    _axios.default.post("/wallet/withdraw-request", {
      pin: pin,
      amount: +amount * 100
    }).then(function (_ref2) {
      var data = _ref2.data;
      getWallet();
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        withdrawAmount: "",
        withdrawAmountPassword: "",
        isSaving: false,
        error: ""
      }));

      _reactToastify.toast.success(translations.withdrawSuccess);

      window.xtremepush("tag", "Wallet.Withdraw", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE
      }));
    }).catch(function (_ref3) {
      var _rest$response, _rest$response2, _rest$response2$data, _rest$response5, _rest$response5$data, _rest$response6, _rest$response6$data;

      var error = _ref3.error,
          rest = _objectWithoutProperties(_ref3, ["error"]);

      setForm(_objectSpread(_objectSpread({}, form), {}, {
        isSaving: false,
        error: "".concat(translations.withdraw, " ").concat(translations.unsuccessful)
      }));

      if ((rest === null || rest === void 0 ? void 0 : (_rest$response = rest.response) === null || _rest$response === void 0 ? void 0 : _rest$response.code) === 401) {
        onError(error);
      }

      if (rest !== null && rest !== void 0 && (_rest$response2 = rest.response) !== null && _rest$response2 !== void 0 && (_rest$response2$data = _rest$response2.data) !== null && _rest$response2$data !== void 0 && _rest$response2$data.errors) {
        var _rest$response3, _rest$response3$data, _rest$response3$data$, _rest$response4, _rest$response4$data, _rest$response4$data$;

        if (rest !== null && rest !== void 0 && (_rest$response3 = rest.response) !== null && _rest$response3 !== void 0 && (_rest$response3$data = _rest$response3.data) !== null && _rest$response3$data !== void 0 && (_rest$response3$data$ = _rest$response3$data.errors) !== null && _rest$response3$data$ !== void 0 && _rest$response3$data$.amount) {
          _reactToastify.toast.error("".concat(translations.errorWithdraw.replace("$1", currencySymbol)));
        } else if (rest !== null && rest !== void 0 && (_rest$response4 = rest.response) !== null && _rest$response4 !== void 0 && (_rest$response4$data = _rest$response4.data) !== null && _rest$response4$data !== void 0 && (_rest$response4$data$ = _rest$response4$data.errors) !== null && _rest$response4$data$ !== void 0 && _rest$response4$data$.password) {
          _reactToastify.toast.error("".concat(translations.invalid, " ").concat(translations.pin));
        }
      } else if ((rest === null || rest === void 0 ? void 0 : (_rest$response5 = rest.response) === null || _rest$response5 === void 0 ? void 0 : (_rest$response5$data = _rest$response5.data) === null || _rest$response5$data === void 0 ? void 0 : _rest$response5$data.message) === "This user has no payment source") {
        _reactToastify.toast.error(translations.withdrawErrorNoCardAdded);
      } else if (rest !== null && rest !== void 0 && (_rest$response6 = rest.response) !== null && _rest$response6 !== void 0 && (_rest$response6$data = _rest$response6.data) !== null && _rest$response6$data !== void 0 && _rest$response6$data.message) {
        _reactToastify.toast.error(rest.response.data.message);
      } else {
        onError(error);
      }
    });
  };

  var amountHigherThanBalance = +withdrawAmount * 100 > balance;
  var isAmountValid = withdrawAmount === "" || !isNaN(withdrawAmount) && withdrawAmount > 0;
  var isPinValid = withdrawAmountPassword === "" || withdrawAmountPassword.length > 3 && withdrawAmountPassword.length < 7;
  var isFormValid = withdrawAmount !== "" && isAmountValid && withdrawAmountPassword !== "" && isPinValid && !amountHigherThanBalance;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    isError: !isAmountValid,
    onChange: handleTextboxChanged,
    value: withdrawAmount,
    name: "withdrawAmount",
    type: "tel",
    prefix: currencySymbol,
    placeholder: translations.amount
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: !isAmountValid
  }, translations.invalid, " ", translations.amount), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: amountHigherThanBalance
  }, translations.withdrawErrorAmountTooHigh), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    onChange: handleTextboxChanged,
    value: withdrawAmountPassword,
    name: "withdrawAmountPassword",
    type: "password",
    pattern: "[0-9]*",
    inputMode: "numeric",
    placeholder: translations.pin
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: !isPinValid
  }, translations.invalid, " ", translations.pin), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    noDisabledStyles: true,
    disabled: !isFormValid || isSaving || errorMessage,
    errorMessage: errorMessage,
    isLoading: isSaving,
    onClick: function onClick() {
      return withdraw(withdrawAmount, withdrawAmountPassword);
    },
    size: "sm"
  }, translations.withdraw));
};

var _default = WalletButtonsWithdraw;
exports.default = _default;